import React, { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { findBelt } from "./cardsData";
import { formatDate } from "../../utils/formatDate";
import { Dots } from "../Loader/loader";
import { fullName } from "../../utils/fullName";

// Trainer view: card requests from the trainees who picked this trainer.
const CardRequests = () => {
  const { user, fetchCardRequests, decideCardRequest } = useAuth();
  const [requests, setRequests] = useState(null);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      setRequests(await fetchCardRequests());
    } catch {
      setError("Չհաջողվեց բեռնել հայտերը։");
      setRequests([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user.is_trainer) load();
  }, [user.is_trainer, load]);

  if (!user.is_trainer) return <Navigate to="/profile" replace />;

  const decide = async (id, decision) => {
    setError("");
    setBusyId(id);
    try {
      await decideCardRequest(id, decision);
      await load();
    } catch {
      setError("Չհաջողվեց կատարել գործողությունը։");
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div className="account-panel">
      <h2 className="account-title">Քարտի հայտեր</h2>
      {error && <div className="auth-alert">{error}</div>}
      {requests === null && <Dots />}
      {requests && requests.length === 0 && <p className="auth-muted">Սպասող հայտեր չկան։</p>}
      <ul className="request-list">
        {(requests || []).map((r) => {
          const wanted = findBelt(r.belt);
          const current = findBelt(r.current_belt);
          return (
            <li key={r.id} className="request-item">
              <img src={r.member.image_url} alt="" />
              <div className="request-info">
                <strong>
                  {fullName(r.member)}
                </strong>
                <span>
                  {current?.label} → <b>{wanted?.label}</b>
                </span>
                <span className="auth-muted">{formatDate(r.created_at)}</span>
              </div>
              <div className="request-actions">
                <button
                  type="button"
                  className="auth-btn"
                  disabled={busyId === r.id}
                  onClick={() => decide(r.id, "approve")}
                >
                  Հաստատել
                </button>
                <button
                  type="button"
                  className="auth-btn outline"
                  disabled={busyId === r.id}
                  onClick={() => decide(r.id, "reject")}
                >
                  Մերժել
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CardRequests;
